import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const PURCHASES = ['María de Buenos Aires', 'Florencia de Córdoba', 'Valentina de Rosario', 'Camila de Mendoza', 'Sofía de Tucumán', 'Julieta de Mar del Plata', 'Agustina de La Plata', 'Daniela de Salta'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNextPopup = () => {
    // Pick a random purchase
    const randomPurchase = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
    setCurrentPurchase(randomPurchase);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 8 to 15 seconds
      const nextDelay = Math.floor(Math.random() * (15000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-234">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto cursor-pointer" onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-235">
          <div className="bg-white rounded-lg shadow-2xl border border-gray-100 p-4 flex items-start gap-4 relative overflow-hidden" data-id="element-236">
            {/* Accent line */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-green-500" data-id="element-237" />

            <div className="bg-green-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-238">
              <ShoppingBagIcon className="w-5 h-5 text-green-600" data-id="element-239" />
            </div>

            <div className="flex-1 pr-4" data-id="element-240">
              <p className="text-sm text-gray-800 font-medium" data-id="element-241">
                <span className="font-bold" data-id="element-242">{currentPurchase}</span> acaba de
                comprar el MÉTODO CALMA®
              </p>
              <p className="text-xs text-gray-500 mt-1" data-id="element-243">Hace unos instantes</p>
            </div>

            <button onClick={e => {
          e.stopPropagation();
          setIsVisible(false);
        }} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-244">
              <XIcon className="w-4 h-4" data-id="element-245" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}